import { render, staticRenderFns } from "./SubmissionError.vue?vue&type=template&id=31229ac1&"
import script from "./SubmissionError.vue?vue&type=script&lang=js&"
export * from "./SubmissionError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports